import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Footer Top */}
        <div className="footer-top">
          <div className="footer-column">
            <h3 className="footer-logo">BEAUTYPRO</h3>
            <div className="footer-social">
              <a 
                href="https://www.instagram.com/beautypro_storee?igsh=MWlqdnJjdzY4YnR2eQ%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
                <span>@Beautypro_storee</span>
              </a>
              <a 
                href="https://www.facebook.com/share/17hgH9n7j7/?mibextid=wwXIfr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
                <span>BeautyPro</span>
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">{t('footer.shop')}</h4>
            <ul className="footer-links">
              <li><button onClick={() => navigate('/shop')}>{t('footer.collection')}</button></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">{t('footer.support')}</h4>
            <ul className="footer-links">
              <li><button onClick={() => navigate('/contact')}>{t('footer.contact')}</button></li>
              
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">{t('footer.contact')}</h4>
            <ul className="footer-contact">
              <li>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <a href="tel:+995577188177">+995 577 188 177</a>
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <a href="mailto:store@beautypro.ge">store@beautypro.ge</a>
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>{t('footer.location')}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} BEAUTYPRO. {t('footer.rights')}
            </p>
            <div className="footer-legal">
              <button onClick={() => navigate('/terms')}>{t('footer.terms')}</button>
              <span className="separator">•</span>
              <button onClick={() => navigate('/privacy')}>{t('footer.privacy')}</button>
              <span className="separator">•</span>
              <button onClick={() => navigate('/money-return')}>{t('footer.refund')}</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;